'use client';

import Core from '@/components/Core';
import CoreData from '@/textContent/cores/Data.json';
import { Fragment } from 'react';
import Hero from '@/components/Hero';
import Mission from '@/components/Mission';
import Photogrid from '@/components/Photogrid';
import { motion } from 'framer-motion';
import photosData from '@/textContent/photogrid/photo.json';

/* ---------------- Animation Variants ---------------- */

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut',
        },
    },
};

const staggerContainer = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.15,
        },
    },
};

const Page = () => {
    return (
        <Fragment>
            {/* ================= HERO ================= */}
            <motion.div variants={fadeUp} initial="hidden" animate="visible">
                <Hero
                    image="/images/company-vector.png"
                    showShadowOnImage={false}
                    heading="Beyond code, beyond expectations. Wahni IT Solutions"
                    caption="Beyond the code, beyond expectations. We're Wahni IT Solutions, where innovation meets expertise to fuel your business transformation.
We help businesses design, build, and scale technology that creates lasting impact."
                />
            </motion.div>

            {/* ================= MISSION ================= */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <Mission />
            </motion.div>

            {/* ================= PHOTO GRID ================= */}
            <motion.div
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <motion.div variants={fadeUp}>
                    <Photogrid images={photosData} />
                </motion.div>
            </motion.div>

            {/* ================= CORE VALUES ================= */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <Core data={CoreData} />
            </motion.div>
        </Fragment>
    );
};

export default Page;
